/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-23 12:01:29
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-29 15:58:08
 */

/**
 * PhotoContent 组件
 *
 * 功能：显示照片或视频的主内容区域
 * 包含：
 * - 上一张/下一张导航按钮
 * - 照片/视频展示
 * - 鼠标交互（缩放、拖动）
 * - 来源信息提示
 * - 可接收子组件（如ActionBar）
 */
import React, { RefObject } from 'react'

import classnames from 'classnames'
import CONFIG from '../../../../constants/config'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

interface Photo {
  mediaType?: number
  largeURL?: string
  videoURL?: string
}

interface PhotoContentProps {
  photo: Photo
  isLimitViewByPhotoCountPrev?: boolean
  isLimitViewByPhotoCountNext?: boolean
  activeIndex: number
  totalPhotos: number
  scale: number
  rotate: number
  imgRef: RefObject<HTMLImageElement>
  aiProcessing: boolean
  onPrev: () => void
  onNext: () => void
  onMouseDown: (e: React.MouseEvent) => void
  onMouseUp: () => void
  onMouseOut: () => void
  onMouseMove: (e: React.MouseEvent) => void
  onVideoPlay?: () => void
  children?: React.ReactNode
}

const PhotoContent: React.FC<PhotoContentProps> = ({
  photo,
  isLimitViewByPhotoCountPrev,
  isLimitViewByPhotoCountNext,
  activeIndex,
  totalPhotos,
  scale,
  rotate,
  imgRef,
  aiProcessing,
  onPrev,
  onNext,
  onMouseDown,
  onMouseUp,
  onMouseOut,
  onMouseMove,
  onVideoPlay,
  children
}) => {
  const isFirstPhoto = activeIndex <= 0
  const isLastPhoto = activeIndex >= totalPhotos - 1
  const isPhoto = (photo.mediaType ?? 0) === 0

  return (
    <div className="photo">
      <div>
        <div
          className={classnames('nav-wrapper', 'nav-prev', {
            disabled: isFirstPhoto || isLimitViewByPhotoCountPrev
          })}
          onClick={onPrev}
          style={{ display: aiProcessing ? 'none' : 'block' }}
        >
          <LeftOutlined className="nav-button" />
        </div>

        {isPhoto ? (
          <img
            ref={imgRef}
            draggable={false}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onMouseOut={onMouseOut}
            onMouseMove={onMouseMove}
            className={classnames({ 'move-photo': scale > 100 })}
            style={{
              transform: `translate3d(-50%, -50%, 0) scale(${
                scale / 100
              }) rotate(${rotate}deg)`
            }}
            src={photo.largeURL}
            alt=""
          />
        ) : (
          <video
            src={photo.videoURL}
            poster={photo.largeURL}
            onPlay={onVideoPlay}
            controls
          ></video>
        )}

        <div
          className={classnames('nav-wrapper', 'nav-next', {
            disabled: isLastPhoto || isLimitViewByPhotoCountNext
          })}
          onClick={onNext}
          style={{ display: aiProcessing ? 'none' : 'block' }}
        >
          <RightOutlined className="nav-button" />
        </div>

        {children}
      </div>
    </div>
  )
}

export default PhotoContent
